module.exports = __webpack_public_path__ + "img/symbol_2.1bdf408a.png";